import React from 'react';
import useRUMView from 'common-datadog/useRUMView';
import { Typography } from '@mui/material';

import Screen from '../Screen';
import CreditBlockForm from '../CreditBlockForm';

const LockedFile = ({ failedUnlock }) => {
  useRUMView('locked');

  const header = failedUnlock
    ? 'Looks like your file is still locked.'
    : "You're unable to prequalify because your credit file is locked.";
  const subheader = failedUnlock
    ? "If you haven't already, please contact the relevant provider to unlock your credit file."
    : 'The quickest and easiest way to unlock your credit file is to contact the service provider you used to lock it.';

  return (
    <Screen
      header={header}
      subheader={subheader}
    >
      {!failedUnlock && (
        <Typography variant="body1">
          Once it&apos;s unlocked, you can continue your application.
        </Typography>
      )}
      <CreditBlockForm status="locked" />
    </Screen>
  );
};

export default LockedFile;
